import React from 'react';

export const CustomPrevArrow = (props: {
  className?: string;
  style?: React.CSSProperties;
  onClick?: React.MouseEventHandler;
}) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, width: '47px', height: '109px' }}
      onClick={onClick}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="45"
        height="104"
        viewBox="0 0 45 104"
        fill="none"
      >
        <g filter="url(#filter0_d_4395_6227)">
          <path
            d="M33.07 11.6341L14.7494 49.6837L33.084 90.1136L30.4762 91.2954L11.5898 49.6483L30.4902 10.3927L33.07 11.6341Z"
            fill="#EE2737"
            fillOpacity="0.6"
            shapeRendering="crispEdges"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_4395_6227"
            x="0.423551"
            y="0.180791"
            width="43.8287"
            height="103.235"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="0.954384" />
            <feGaussianBlur stdDeviation="5.58315" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.933333 0 0 0 0 0.152941 0 0 0 0 0.215686 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_4395_6227"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_4395_6227"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </div>
  );
};

export const CustomNextArrow = (props: {
  className?: string;
  style?: React.CSSProperties;
  onClick?: React.MouseEventHandler;
}) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, width: '47px', height: '109px' }}
      onClick={onClick}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="45"
        height="104"
        viewBox="0 0 45 104"
        fill="none"
      >
        <g filter="url(#filter0_d_4395_6229)">
          <path
            d="M11.7972 90.054L30.1178 52.0044L11.7832 11.5745L14.391 10.3927L33.2773 52.0399L14.377 91.2954L11.7972 90.054Z"
            fill="#EE2737"
            fillOpacity="0.6"
            shapeRendering="crispEdges"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_4395_6229"
            x="0.618863"
            y="0.180791"
            width="43.8248"
            height="103.235"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="0.954384" />
            <feGaussianBlur stdDeviation="5.58315" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.933333 0 0 0 0 0.152941 0 0 0 0 0.215686 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_4395_6229"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_4395_6229"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </div>
  );
};
